/** @format */

import {styled} from '@mui/material/styles';
import {Paper} from '@mui/material';

export const ModalPaper = styled(Paper, {
  shouldForwardProp: prop => prop !== 'isSuccess',
})<{isSuccess?: boolean}>(({theme, isSuccess}) => ({
  borderRadius: isSuccess ? '32px' : '8px',
  overflow: 'hidden',
  outline: 'none',

  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: `calc(100vw - ${theme.spacing(8)})`,
  maxHeight: `calc(100vh - ${theme.spacing(8)})`,
  overflowY: 'auto',
}));
